"use client";

import { useState } from "react";
import { ExamLandingSection } from "../exam-landing-section";
import { TitleHeader } from "../title-header";
import { Accordion } from "@/components/exams/not-logged-landing/components/exams-faq/components/accordion";
import { FaqCategories } from "@/components/exams/not-logged-landing/components/exams-faq/components/faq-categories";

const general: {
  question: string;
  answer: string;
}[] = [
  {
    question: "Czy dostęp do egzaminów Remedium jest bezpłatny?",
    answer:
      "Tak, dostęp do egzaminów jest na Remedium całkowicie bezpłatny. Jedynym wymogiem jest założenie konta, co również nie wiąże się z żadnymi opłatami.",
  },
  // {
  //   question: "Gdzie mogę zobaczyć terminarz egzaminów?",
  //   answer: 'Aby pomóc Ci w wymagającym czasie przygotowań do LEK/LDEK/PES, stworzyliśmy kalendarz egzaminów [link]. Kliknij "przypomnienie", a damy Ci znać o zbliżającym się końcu zapisów na interesujący Cię egzamin, jak również o samym "wielkim dniu".',
  // },
  {
    question: "Czy mogę rozwiązać każdy egzamin na platformie?",
    answer:
      "Tak, każdy zalogowany użytkownik może bezpłatnie wielokrotnie rozwiązywać wszystkie egzaminy.",
  },
];

const LEK: {
  question: string;
  answer: string;
}[] = [
  {
    question: "Ile pytań jest na Lekarskim Egzaminie Końcowym (LEK)?",
    answer:
      "LEK składa się z 200 pytań z jedną poprawną odpowiedzią. Warto przy tym pamiętać, że część pytań może zostań anulowana (i zwykle tak się dzieje). Aby uzyskać pozytywny wynik z LEK albo LDEK, musisz uzyskać co najmniej 56% maksymalnej liczby punktów.",
  },
  {
    question: "Gdzie znajdę aktualną bazę pytań CEM do LEK?",
    answer:
      'W ramach egzaminów Remedium znajdziesz całą aktualną bazę pytań CEM do LEK – bezpłatnie: <a href="https://remedium.md/egzaminy-medyczne/lek/baza"> https://remedium.md/egzaminy-medyczne/lek/baza </a>',
  },
  {
    question: "Gdzie znajdę archiwalne pytania do LEK?",
    answer:
      'Nowe pytania na LEK-u często są podobne do archiwalnych. W ramach przygotowań do egzaminu warto przerobić również stare testy, które także są dostępne bezpłatnie na Remedium: <a href="https://remedium.md/egzaminy-medyczne/lek/archiwum"> https://remedium.md/egzaminy-medyczne/lek/archiwum </a>',
  },
  {
    question: "Czy dostępna jest cała baza pytań LEK?",
    answer:
      "Tak, na Remedium dostępna jest cała baza pytań do LEK. W przypadku dodania nowych pytań przez CEM, zostają one uzupełnione również na Remedium.",
  },
  {
    question: "Ile trwa LEK?",
    answer: "Podczas LEK-u czas na rozwiązanie 200 pytań wynosi 4 h.",
  },
  {
    question: "Ile kosztuje podejście do LEK?",
    answer:
      "Pierwsze podejście do LEK jest darmowe. Drugie i kolejne wymagają uiszczenia opłaty w wysokości 100 zł. Z kolei chęć złożenia egzaminu w języku angielskim wiąże się z kosztem 340 zł.",
  },
  {
    question: "Jak zapisać się na LEK?",
    answer:
      'Zapisów na LEK dokonuje się poprzez system SMK. Szczegółową instrukcję znajdziesz tutaj: <a href="https://remedium.md/vademecum/lekldek/lek-i-ldek-dla-absolwentow"> https://remedium.md/vademecum/lekldek </a>',
  },
  {
    question: "Kiedy można zgłaszać zastrzeżenia do pytań na LEK?",
    answer:
      "Uwagi do pytań, które pojawiły się na LEK, można zgłaszać jedynie w trakcie egzaminu albo bezpośrednio po jego zakończeniu.",
  },
];

const LDEK: {
  question: string;
  answer: string;
}[] = [
  {
    question:
      "Ile pytań jest na Lekarsko-Dentystycznym Egzaminie Końcowym (LDEK)?",
    answer:
      "LDEK składa się z 200 pytań z jedną poprawną odpowiedzią. Warto przy tym pamiętać, że część pytań może zostań anulowana (i zwykle tak się dzieje). Aby uzyskać pozytywny wynik z LEK albo LDEK, musisz uzyskać co najmniej 56% maksymalnej liczby punktów.",
  },
  {
    question: "Gdzie znajdę aktualną bazę pytań do LDEK?",
    answer:
      'W ramach egzaminów Remedium znajdziesz całą aktualną bazę pytań CEM do LDEK – bezpłatnie: <a href="https://remedium.md/egzaminy-medyczne/ldek/baza"> https://remedium.md/egzaminy-medyczne/ldek/baza </a>',
  },
  {
    question: "Czy dostępna jest cała baza pytań do LDEK?",
    answer:
      "Tak, na Remedium dostępna jest cała baza pytań do LDEK. W przypadku dodania nowych pytań przez CEM, zostają one uzupełnione również na Remedium.",
  },
  {
    question: "Gdzie znajdę archiwalne pytania do LDEK?",
    answer:
      'Nowe pytania na LDEK często są podobne do archiwalnych. W ramach przygotowań do egzaminu warto przerobić również stare testy, które także są dostępne bezpłatnie na Remedium: <a href="https://remedium.md/egzaminy-medyczne/ldek/archiwum"> https://remedium.md/egzaminy-medyczne/ldek/archiwum </a>',
  },
  {
    question: "Ile trwa LDEK?",
    answer: "Podczas LDEK-u czas na rozwiązanie 200 pytań wynosi 4 h.",
  },
  {
    question: "Ile kosztuje podejście do LDEK?",
    answer:
      "Pierwsze podejście do LDEK jest darmowe. Drugie i kolejne wymagają uiszczenia opłaty w wysokości 100 zł. Z kolei chęć złożenia egzaminu w języku angielskim wiąże się z kosztem 340 zł.",
  },
  {
    question: "Jak zapisać się na LDEK?",
    answer:
      'Zapisów na LDEK dokonuje się poprzez system SMK. Szczegółową instrukcję znajdziesz tutaj: <a href="https://remedium.md/vademecum/lekldek/lek-i-ldek-dla-absolwentow"> https://remedium.md/vademecum/lekldek/lek-i-ldek-dla-absolwentow </a>',
  },
  {
    question: "Kiedy można zgłaszać zastrzeżenia do pytań na LDEK?",
    answer:
      "Uwagi do pytań, które pojawiły się na LDEK, można zgłaszać jedynie w trakcie egzaminu albo bezpośrednio po jego zakończeniu.",
  },
];

const PES: {
  question: string;
  answer: string;
}[] = [
  {
    question: "Czy dostępna jest cała baza pytań do PES?",
    answer:
      "W ramach PES nie funkcjonuje baza analogiczna do LEK i LDEK. Na Remedium dostępne są jednak wszystkie archiwalne pytania do poszczególnych egzaminów specjalizacyjnych. W przypadku dodania nowych pytań przez CEM, zostają one uzupełnione również na Remedium.",
  },
  {
    question: "Ile pytań jest na państwowym egzaminie specjalizacyjnym?",
    answer:
      "Część testowa PES składa się ze 120 pytań zawierających pięć wariantów odpowiedzi, z których tylko jeden jest prawidłowy. Aby ją zaliczyć, należy uzyskać co najmniej 60% punktów.",
  },
  {
    question: "Kto może być zwolniony z części ustnej PES?",
    answer:
      "Osoby, które uzyskały w części pisemnej wynik co najmniej 75%, zostają zwolnione z egzaminu ustnego. Warto więc rozwiązywać archiwalne pytania, aby wiedzieć, czego się spodziewać.",
  },
  {
    question: "Ile trwa część testowa PES?",
    answer: "Podczas PES czas na rozwiązanie 120 pytań wynosi 3 godziny.",
  },
  {
    question: "Ile kosztuje podejście do PES?",
    answer:
      "Dwa pierwsze podejścia do PES są darmowe. Trzecie i kolejne wymagają natomiast uiszczenia opłaty w wysokości 700 zł.",
  },
  {
    question: "Jak zapisać się na PES?",
    answer:
      'Do PES może podejść osoba, która 1) ukończyła przedostatni rok szkolenia specjalizacyjnego; 2) uzyskała potwierdzenie zakończenia szkolenia specjalizacyjnego; 3) posiadający decyzję o uznaniu dotychczasowego dorobku naukowego lub zawodowego za równoważny ze zrealizowaniem programu szkolenia specjalizacyjnego w danej dziedzinie ochrony zdrowia. Szczegółowa instrukcja zapisów jest dostępna tutaj: <a href="https://remedium.md/vademecum/rezydentura/kto-moze-zapisac-sie-na-pes-i-jak-to-zrobic"> https://remedium.md/vademecum/rezydentura/kto-moze-zapisac-sie-na-pes-i-jak-to-zrobic </a>',
  },
];

const items = [general, LEK, LDEK, PES];

const categories = ["Ogólne", "LEK", "LDEK", "PES"];

export const ExamsFaq = () => {
  const [activeCategory, setActiveCategory] = useState(0);

  return (
    <ExamLandingSection>
      <TitleHeader
        smallTitle="FAQ"
        largeTitle="Wszystko co musisz wiedzieć"
      ></TitleHeader>
      <FaqCategories
        items={categories}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />
      {/* <Accordion items={items[activeCategory]} /> */}
      {items.map((item, index) => (
        <Accordion items={item} active={index === activeCategory} key={index} />
      ))}
    </ExamLandingSection>
  );
};
